import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  BUILD_ASSET,
  UPDATE_COMMITMENTS_SUCCESS,
  ASSET_CHANGED,
  UPDATE_ASSETS_FAILURE,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
} from './../../actions/types'

const byId = (state = {}, {type, payload}) => {
  switch (type) {
    case LOAN_APPLICATION_FETCH_SUCCESS:
      return payload.applicationFlow.assets || state
    case ASSET_CHANGED:
      const { key } = payload
      const updatedAsset = {...state[key], ...payload }
      return { ...state, [key]: updatedAsset }
    case BUILD_ASSET:
      return {
        ...state,
        [payload.key]: { ...payload.data, errors: {} }
      }
    case UPDATE_COMMITMENTS_SUCCESS:
      if (payload.assets !== undefined) {
        return payload.assets || {}
      } else {
        return state
      }
    case LOAN_APPLICATION_USER_GOTO_SUCCESS:
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
      if (payload.assets !== undefined) {
        return payload.assets || {}
      } else {
        return state
      }
    case UPDATE_ASSETS_FAILURE:
      return payload.entities || {}
    default:
      return state;
  }
}

export default byId;
